import AddCircleIcon from '@mui/icons-material/AddCircle';
import CloseIcon from '@mui/icons-material/Close';
import SwapVertIcon from '@mui/icons-material/SwapVert';
import { Button,Checkbox,Dialog,DialogContent,DialogTitle,Divider,FormControlLabel,IconButton,Stack,TextField,Tooltip,Typography } from '@mui/material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { useMutation } from '@tanstack/react-query';
import { ptBR } from 'date-fns/locale';
import React,{ useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BiTrash } from 'react-icons/bi';
import { FaMinus,FaPlus } from "react-icons/fa";
import { ThreeDots } from 'react-loading-icons';
import { toast } from 'react-toastify';
import AttToken from '../../../helpers/attToken';
import getEndOfToday from '../../../helpers/getEndOfToday';
import { trackEventMatomo } from '../../../helpers/matomo';
import PlanoDeAcao,{ planoDeAcaoType as LegacyPlanoDeAcaoType } from '../../../service/PlanoDeAcao';
import queryClient from '../../../service/query';
import { planoDeAcaoType,taskType } from '../../../types/plano-de-acao/types';
import ImagesCmp from '../../ImagesCmp';
import UserSelector from '../../UserSelector';
import { SpanBelongs,Title } from '../style/stylesPlano';


type props = {
  openModal: boolean,
  setOpenModal: Function,
  planos: planoDeAcaoType[],
  setPlanos: Function,
  handleOpen: Function,
  analiseId: string,
  handleCloseFather: Function,
};

type FormPaProps = {
  plano: planoDeAcaoType,
  setPlanos: Function,
  planos: planoDeAcaoType[],
  i: number,
};

type TaskCompProps = {
  index: number,
  task: taskType
  setPlanos: Function,
  planos: planoDeAcaoType[],
  plano: planoDeAcaoType,
  setMinDateValue: Function
};

const planoService = new PlanoDeAcao();

const TaskComp = ({ task, index, planos, setPlanos, plano, setMinDateValue }: TaskCompProps) => {
  const { t } = useTranslation('translation');
  const handleAddTaskResponsible = (uid: string) => {
    task.responsavel = uid;
    setPlanos([...planos]);
  };

  return (
    <>
      <Stack
        direction="column"
        spacing={2}
        padding={2}
        justifyContent="flex-start"
        alignItems="flex-start"
        width='100%'
      >
        <TextField
          variant='outlined'
          onClick={() => trackEventMatomo('modal abre PA', 'click', 'textarea', 'edita valor')}
          fullWidth
          label='Nome da tarefa'
          value={task.nome}
          onChange={(e) => {
            task.nome = e.target.value;
            setPlanos([...planos]);
          }}
          required
        />
        <Typography color='textDisabled' fontWeight={600}>{t('ActionPlan.Modal.responsible')}</Typography>
        <UserSelector
          callback={handleAddTaskResponsible}
          userLabel={'Selecione o usuário responsável pela Tarefa'}
          defaultSelected={task.responsavel || null}
        />
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
          <DesktopDatePicker
            label="Realizar tarefa até"
            minDate={getEndOfToday().endDate}
            maxDate={plano.dataLimite ? new Date(plano.dataLimite) : undefined}
            value={task.dataLimite ? new Date(task.dataLimite) : new Date()}
            onChange={(date) => {
              trackEventMatomo('modal abre PA', 'click', 'datepicker', 'edita data');
              if (!date) return;

              const thisMilisseconds = new Date(date).getTime();
              let minDate = thisMilisseconds;
              plano.tasks.forEach((task, i) => {
                if (i !== index && task.dataLimite > minDate) {
                  minDate = task.dataLimite;
                }
              });

              setMinDateValue(new Date(minDate));
              task.dataLimite = new Date(date).getTime();
              setPlanos([...planos]);
            }}
            disableFuture={false}
            slotProps={{
              textField: {
                required: true,
                onKeyDown: (e) => e.preventDefault(),
                sx: {
                  maxWidth: 200,
                  marginTop: '10px',
                  backgroundColor: 'white',
                  '& .MuiInputBase-input': {
                    height: 'calc(1em + 10px)',
                    display: 'flex',
                    padding: '10px',
                    alignItems: 'center',
                  },
                },
              },
            }}
          />
        </LocalizationProvider>
        <FormControlLabel control={<Checkbox
          checked={task.obrigatorioEvidencia}
          onChange={(e) => {
            task.obrigatorioEvidencia = e.target.checked;
            setPlanos([...planos]);
          }}
        />} label={t('ActionPlan.Modal.evidenceRequired').slice(0, -1)} />
        <TextField
          fullWidth
          multiline
          inputProps={{
            maxLength: 1000,
          }}
          rows={4}
          maxRows={4}
          onClick={() => trackEventMatomo('modal abre PA', 'click', 'input', 'edita valor')}
          onChange={(e) => {
            task.detalhes = e.target.value;
            setPlanos([...planos]);
          }}
          label={t('ActionPlan.Modal.detailTaskOptional')}
        />
        <IconButton
          color='error'
          onClick={() => {
            trackEventMatomo('modal abre PA', 'click', 'button', 'remove task');
            const newTasks = plano.tasks.filter((el, ind) => ind !== index);
            plano.tasks = newTasks;
            setPlanos([...planos]);
          }}
        >
          <BiTrash />
        </IconButton>
      </Stack>
      <Divider orientation='horizontal' />
    </>
  );
};

const FormPA = ({ plano, setPlanos, planos, i }: FormPaProps,) => {
  const [minDateValue, setMinDateValue] = useState<Date>(getEndOfToday().endDate);
  const [inverteOrdem, setInverteOrdem] = useState(true);
  const [showSubDetail, setShowSubDetail] = useState<boolean>(false);
  const { t } = useTranslation('translation');

  const addTask = () => {
    const defaultTask: taskType = {
      nome: 'Nova Tarefa',
      status: 'pendente',
      responsavel: '',
      obrigatorioEvidencia: false,
      detalhes: '',
      dataLimite: getEndOfToday().endDate.getTime(),
    };
    if (!plano.tasks || !plano.tasks.length) {
      plano.tasks = [defaultTask];
    } else { plano.tasks.push(defaultTask); }
    setPlanos([...planos]);
  };

  const handleAddPlanResponsible = (uid: string) => {
    plano.responsavel = uid;
    setPlanos([...planos]);
  };

  return (
    <Stack
      spacing={1}
      padding={1.5}
      direction='column'
      justifyContent='flex-start'
      justifyItems='flex-start'
      width='100%'
      style={{ backgroundColor: '#dbd6cc' }}>
      <Typography variant='h6' fontWeight={600} sx={{ color: '#47AA9C' }}>{t('ActionPlan.Modal.planOptions')}</Typography>
      <TextField
        onClick={() => trackEventMatomo('modal abre PA', 'click', 'input', 'edita valor')}
        fullWidth
        label={t('ActionPlan.Modal.actionPlanName')}
        value={plano.nome}
        onChange={(e) => {
          plano.nome = e.target.value;
          setPlanos([...planos]);
        }}
        required
      />
      <Typography color='textDisabled' fontWeight={600}>{t('ActionPlan.Modal.actionPlanResponsible')}</Typography>
      <Stack direction='column' width='100%' padding={1.5} spacing={2}>
        <UserSelector
          callback={handleAddPlanResponsible}
          userLabel={t('ActionPlan.Modal.selectPlanResponsible')}
          defaultSelected={plano.responsavel || null}
        />
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
          <DesktopDatePicker
            label={t('ActionPlan.Modal.finishPlanBy')}
            minDate={minDateValue}
            value={plano.dataLimite ? new Date(plano.dataLimite) : new Date()}
            onChange={(date) => {
              trackEventMatomo('modal abre PA', 'click', 'datepicker', 'edita data');
              if (!date) return;
              plano.dataLimite = new Date(date).getTime();
              setPlanos([...planos]);
            }}
            slotProps={{
              textField: {
                required: true,
                onKeyDown: (e) => e.preventDefault(),
                sx: {
                  maxWidth: 200,
                  marginTop: '10px',
                  backgroundColor: 'white',
                  '& .MuiInputBase-input': {
                    height: 'calc(1em + 10px)',
                    display: 'flex',
                    padding: '10px',
                    alignItems: 'center',
                  },
                },
              },
            }}
          />
        </LocalizationProvider>
      </Stack>
      <Title>{t('Reports.columns.notAccording')}:</Title>
      <Stack direction='column' spacing={1} paddingLeft={2}>
        {plano.naoConformidades.map((sub, index) => (
          <>
            <Stack
              direction='row'
              justifyContent='space-between'
              width='100%'
              paddingTop={1}
              paddingBottom={1}
            >
              <Typography key={index} variant='body1'>{index + 1} - {sub.nome}</Typography>
              <IconButton
                onClick={(event) => {
                  trackEventMatomo('modal abre PA', 'click', 'button', 'exibe nConf');
                  event.preventDefault();
                  setShowSubDetail(!showSubDetail);
                }}
                className='button is-small is-ghost'>
                {!showSubDetail
                  ? <FaPlus />
                  : <FaMinus />}
              </IconButton>
            </Stack>
            {showSubDetail
              && <>
                <Typography>{t('ActionPlan.Modal.evaluation')}</Typography>
                <Stack direction='column' spacing={1} width='100%' justifyContent='flex-start' alignItems='flex-start' paddingLeft={1.5}>
                  {sub.avaliacao && sub.avaliacao.map(ava => (
                    <Typography
                      fontSize={'14px'}
                      fontWeight={`${sub.nota === ava.valor ? 'bold' : '100'}`}
                    >
                      {ava.nome}
                    </Typography>
                  ))}
                  {sub.ocorrencia && <Typography color='textDisabled' fontSize='small' fontWeight={600}>{`${t('ActionPlan.Modal.comment')} ${sub.ocorrencia}`}</Typography>}
                  {sub.img &&
                    <>
                      <ImagesCmp images={sub.img} />
                    </>
                  }
                </Stack>
              </>}
          </>
        ))}
      </Stack>
      <Title>{t('ActionPlan.Modal.defineTasksForThisPlan')}</Title>
      <Stack
        direction="row"
        justifyContent="space-evenly"
        alignItems="center"
      >
        <Tooltip title="Adicionar Tarefa">
          <IconButton
            color='success'
            onClick={() => {
              trackEventMatomo('modal abre PA', 'click', 'button', 'add task');
              addTask();
            }}
          >
            <AddCircleIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title={`${t('ActionPlan.Modal.viewTasks')} ${inverteOrdem ? `${t('ActionPlan.Modal.oldestFirst')}` : `${t('ActionPlan.Modal.newestFirst')}`} ${t('ActionPlan.Modal.creationOrder')}`}>
          <IconButton
            color='primary'
            onClick={() => {
              trackEventMatomo('modal abre PA', 'click', 'button', 'ordena tasks');
              setInverteOrdem(!inverteOrdem);
            }}
          >
            <SwapVertIcon />
          </IconButton>
        </Tooltip>
      </Stack>
      {
        (!plano.tasks || !plano.tasks.length)
        && <SpanBelongs>
          {t('ActionPlan.Modal.noTasksCreatedYet')}
        </SpanBelongs>
      }
      <Stack
        width='100%'
        direction={inverteOrdem ? 'column-reverse' : 'column'}
        spacing={1}
        justifyContent="flex-start"
        alignItems="stretch"
      >
        {plano.tasks
          && plano?.tasks?.map((task, index) => (
            <TaskComp
              key={index}
              task={task}
              index={index}
              planos={planos}
              setPlanos={setPlanos}
              plano={plano}
              setMinDateValue={setMinDateValue}
            />
          ))}
      </Stack>
    </Stack >
  );
};

export default function AbrePlano({
  openModal,
  setOpenModal,
  planos,
  setPlanos,
  handleOpen,
  analiseId,
  handleCloseFather
}: props) {
  const [sending, setSending] = useState(false);
  const { t } = useTranslation('translation');

  const { mutate } = useMutation({
    mutationKey: ['ABRE_PLANO'],
    mutationFn: async (event: React.FormEvent<HTMLFormElement>) => {
      event.preventDefault();
      setSending(true);
      const token = await AttToken();
      if (token) {
        const res = await planoService.startPlano(token, analiseId, planos as unknown as LegacyPlanoDeAcaoType[]);
        return res;
      }
    },
    onSuccess: () => {
      queryClient.resetQueries({ queryKey: ['GET_ANALISES_PENDING'] });
      queryClient.resetQueries({ queryKey: ['GET_ANALISES_FINALIZADAS'] });
      setSending(false);
      setOpenModal();
      handleCloseFather();
      toast.success(`${planos.length} ${planos.length > 1 ? `${t('ActionPlan.Modal.openPlans')} ` : `${t('ActionPlan.Modal.planOpened')} `}`);
    },
    onError: () => {
      setSending(false);
      toast.error(`${t('ActionPlan.Modal.failedToOpenPlans')} `);
    }
  });

  return (
    <Dialog
      fullWidth
      maxWidth='md'
      open={openModal}
      onClose={() => handleOpen()}
      scroll='paper'
    >
      <DialogTitle>{`Abrindo ${planos.length} ${planos.length > 1
        ? `${t('ActionPlan.Modal.plans')} `
        : `${t('ActionPlan.Modal.plan')} `}`}</DialogTitle>
      <IconButton
        aria-label="close"
        onClick={() => handleOpen()}
        sx={(theme) => ({
          position: 'absolute',
          right: 8,
          top: 8,
          color: theme.palette.grey[500],
        })}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent dividers={true}>
        {!sending ? (
          <form
            onSubmit={(e) => {
              trackEventMatomo('modal abre PA', 'click', 'button', 'salva');
              mutate(e);
            }}>
            <Stack
              direction="column"
              spacing={1}
              justifyContent="flex-start"
              alignItems="stretch"
            >
              {planos.length && planos.map((plan, index) => (
                <FormPA
                  key={index}
                  plano={plan}
                  planos={planos}
                  setPlanos={setPlanos}
                  i={index}
                />
              ))}
              <Button
                className='button is-success is-fullwidth'
                disabled={planos.some(plano => !plano.tasks || !plano.tasks.length)}
                type='submit'
              >
                {`${t('ActionPlan.Modal.finishAndOpen')} ${planos.length > 1
                  ? `${t('ActionPlan.Modal.actionPlans')}`
                  : `${t('ActionPlan.Modal.actionPlan')}`}`}
              </Button>
            </Stack>
          </form>
        ) : (
          <Stack
            direction="column"
            spacing={1}
            sx={{
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Typography variant='h5' textAlign='center'>{t('ActionPlan.Modal.openingPlans')}</Typography>
            <ThreeDots speed={.5} stroke="#4D2B78" fill={'#4D2B78'} strokeWidth={1} />
          </Stack>
        )}
      </DialogContent>
    </Dialog >
  );
}
